function getBgValue(n, dim) {
  const threshold = 2 / 6; // 0.33 --<-|->--
  if (n > threshold) {
    return dim === 'vertical' ? 'top' : 'right';
  } else if (n < threshold * -1) {
    return dim === 'vertical' ? 'bottom' : 'left';
  }
  return 'center';
}

export { getBgValue };
